// Маленькая таблица «знак по-русски → латиницей». Вынесена из houseCards.js,
// чтобы главный бандл не тянул из-за одной строчки всю библиотеку трактовок домов.
export const SIGN_RU_TO_EN = {
  'Овен': 'aries', 'Телец': 'taurus', 'Близнецы': 'gemini', 'Рак': 'cancer',
  'Лев': 'leo', 'Дева': 'virgo', 'Весы': 'libra', 'Скорпион': 'scorpio',
  'Стрелец': 'sagittarius', 'Козерог': 'capricorn', 'Водолей': 'aquarius', 'Рыбы': 'pisces',
};

// «в Раке» — предложный падеж знака для подписей «Планета в знаке».
export const SIGN_PREPOSITIONAL = {
  'Овен': 'Овне', 'Телец': 'Тельце', 'Близнецы': 'Близнецах',
  'Рак': 'Раке', 'Лев': 'Льве', 'Дева': 'Деве',
  'Весы': 'Весах', 'Скорпион': 'Скорпионе', 'Стрелец': 'Стрельце',
  'Козерог': 'Козероге', 'Водолей': 'Водолее', 'Рыбы': 'Рыбах',
};
